import api from './api';

export const voiceCloningService = {
  /**
   * Get training configuration (quality tiers, prompts, etc.)
   */
  async getTrainingConfig() {
    const response = await api.get('/voice-cloning/training-config');
    return response.data;
  },

  /**
   * Create a new voice clone project
   */
  async create(name, description = '') {
    const response = await api.post('/voice-cloning', {
      name,
      description,
    });
    return response.data;
  },

  /**
   * Get all voice clones
   */
  async list(page = 1, perPage = 20) {
    const response = await api.get('/voice-cloning', {
      params: { page, per_page: perPage },
    });
    return response.data;
  },

  /**
   * Get voice clone details
   */
  async get(cloneId) {
    const response = await api.get(`/voice-cloning/${cloneId}`);
    return response.data;
  },

  /**
   * Upload voice sample
   */
  async uploadSample(cloneId, file) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post(`/voice-cloning/${cloneId}/samples`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  /**
   * Start training
   */
  async startTraining(cloneId, targetQuality = null) {
    const response = await api.post(`/voice-cloning/${cloneId}/train`, null, {
      params: targetQuality ? { target_quality: targetQuality } : undefined,
    });
    return response.data;
  },

  /**
   * Delete voice clone
   */
  async delete(cloneId) {
    const response = await api.delete(`/voice-cloning/${cloneId}`);
    return response.data;
  },

  /**
   * Get voice clone preview as blob URL
   */
  async getPreview(cloneId) {
    const response = await api.get(`/voice-cloning/${cloneId}/preview`, {
      responseType: 'blob',
    });
    return URL.createObjectURL(response.data);
  },
};

export default voiceCloningService;
